<template>
  <div class="gx-as">
    <h1 class="gx-as__title">售后管理</h1>

    <!-- 筛选栏 -->
    <div class="gx-as__filter">
      <select v-model="searchData.after_sale_type" class="gx-as__select" @change="onTypeChange">
        <option v-for="t in afterSaleTypes" :key="t.val" :value="t.val">{{ t.text }}</option>
      </select>
      <select v-model="searchData.after_sale_status" class="gx-as__select">
        <option value="">全部状态</option>
        <option v-for="s in statusOptions" :key="s.val" :value="s.val">{{ s.text }}</option>
      </select>
      <input v-model="searchData.aftersale_id" class="gx-as__input" placeholder="售后编号" @keyup.enter="doSearch" />
      <input v-model="searchData.order_no" class="gx-as__input" placeholder="订单编号" @keyup.enter="doSearch" />
      <input v-model="searchData.goods_id" class="gx-as__input" placeholder="商品ID" @keyup.enter="doSearch" />
      <div class="gx-as__spacer"></div>
      <button class="gx-as__btn gx-as__btn--primary" @click="doSearch">查询</button>
      <button class="gx-as__btn" @click="resetSearch">重置</button>
    </div>

    <!-- 类型 tabs -->
    <div class="gx-as__tabs">
      <button
        v-for="(t, i) in tabList"
        :key="i"
        class="gx-as__tab"
        :class="{ 'gx-as__tab--on': searchData.after_sale_type === t.val }"
        @click="switchTab(t)"
      >
        {{ t.text }}
        <span v-if="t.num > 0" class="gx-as__tab-num">{{ t.num }}</span>
      </button>
    </div>

    <!-- 表格 -->
    <div class="gx-as__table">
      <table>
        <thead>
          <tr>
            <th v-for="h in ['售后编号', '店铺', '商品信息', '金额', '售后类型', '状态', '时间', '操作']" :key="h">{{ h }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r, i) in list" :key="r.id">
            <td class="gx-as__mono gx-as__link">{{ r.aftersale_id || r.id }}</td>
            <td>{{ r.shop_name || '--' }}</td>
            <td class="gx-as__product">{{ r.product_title || r.goods_name || r.name || '--' }}</td>
            <td class="gx-as__mono gx-as__gold">¥{{ r.amount || r.order_amount || '0.00' }}</td>
            <td>
              <span class="gx-as__tag">{{ r.type_text || r.after_sale_type_text || '--' }}</span>
            </td>
            <td>
              <span class="gx-as__status" :style="statusStyle(r)">{{ r.status_text || r.after_sale_status_text || '--' }}</span>
            </td>
            <td class="gx-as__mono gx-as__dim">{{ r.created_at || r.create_time }}</td>
            <td>
              <button class="gx-as__op" @click="viewDetail(r)">查看详情</button>
            </td>
          </tr>
          <tr v-if="!list.length">
            <td :colspan="8" class="gx-as__empty">暂无售后数据</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 分页 -->
    <div class="gx-as__pager">
      <span class="gx-as__pager-total">共 {{ pageData.total }} 条</span>
      <div class="gx-as__pager-btns">
        <button class="gx-as__page" :disabled="pageData.page <= 1" @click="getList(true, pageData.page - 1)">上一页</button>
        <button v-for="n in pageNums" :key="n" class="gx-as__page" :class="{ 'gx-as__page--on': n === pageData.page }" @click="getList(true, n)">{{ n }}</button>
        <button class="gx-as__page" :disabled="pageData.page >= totalPages" @click="getList(true, pageData.page + 1)">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NewAfterSalesPage',
  data() {
    return {
      searchData: { after_sale_status: '' },
      list: [],
      pageData: { limit: 20, page: 1, total: 0 },
      afterSaleTypes: [{ val: '', text: '全部类型' }],
      statusOptions: [],
      tabList: []
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    }
  },
  created() {
    this.initFilter()
    this.getList(true)
  },
  methods: {
    ...mapActions({
      getAfterSalesfilterData: 'ucenter_order/getAfterSalesfilterData',
      getOrderAfterSalesList: 'ucenter_order/getOrderAfterSalesList'
    }),
    initFilter() {
      this.getAfterSalesfilterData({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const d = res.data
            this.afterSaleTypes = [{ val: '', text: '全部类型' }].concat(
              (d.aftersale_type || []).map((t) => ({ val: t.val, text: t.text || t.label || ('类型' + t.val) }))
            )
            const types = d.aftersale_type || []
            if (types.length && types[0].val !== undefined) {
              this.searchData.after_sale_type = types[0].val
              this.statusOptions = (types[0].status_list || []).map((s) => ({ val: s.val, text: s.text || s.label }))
            }
            this.tabList = (d.tab_list || []).map((t) => ({ val: t.val ?? t.id, text: t.text || t.title || t.label, num: parseInt(t.count_num || 0, 10) || 0 }))
          }
        }
      })
    },
    onTypeChange() {
      const t = this.afterSaleTypes.find((x) => x.val === this.searchData.after_sale_type)
      this.searchData.after_sale_status = ''
      this.pageData.page = 1
      this.getList(true)
    },
    switchTab(t) {
      this.searchData.after_sale_type = t.val
      this.searchData.after_sale_status = ''
      this.pageData.page = 1
      this.getList(true)
    },
    doSearch() {
      this.pageData.page = 1
      this.getList(true)
    },
    resetSearch() {
      this.searchData = { after_sale_status: '' }
      this.pageData.page = 1
      this.getList(true)
    },
    getList(showLoading, page) {
      if (page) this.pageData.page = page
      const param = { limit: this.pageData.limit, page: this.pageData.page }
      Object.assign(param, this.searchData)
      this.getOrderAfterSalesList({
        data: param,
        success: (res) => {
          if (res.code === 200) {
            this.list = res.data.data || []
            this.pageData.total = res.data.total || 0
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }
      })
    },
    viewDetail(r) {
      const route = this.$router.resolve({
        path: '/uc_after_sales_detail',
        query: { id: String(r.id) }
      })
      window.open(route.href, '_blank')
    },
    statusStyle() {
      return { background: 'rgba(251,146,60,.1)', border: '1px solid rgba(251,146,60,.3)', color: '#FB923C' }
    }
  }
}
</script>

<style scoped>
.gx-as {
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px;
  font-family: 'Noto Sans SC', sans-serif;
}
.gx-as__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 24px;
  font-weight: 600;
  color: #1A1A2E;
  margin: 0 0 20px;
}
.gx-as__filter {
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.gx-as__select {
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid rgba(212, 169, 70, .18);
  background: #FFFFFF;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  min-width: 120px;
}
.gx-as__input {
  width: 140px;
  height: 30px;
  padding: 0 9px;
  border-radius: 6px;
  border: 1px solid rgba(212, 169, 70, .18);
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
}
.gx-as__spacer {
  flex: 1;
}
.gx-as__btn {
  height: 30px;
  padding: 0 12px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .18);
  font-size: 12px;
  color: #4A4A6A;
  transition: all .16s;
}
.gx-as__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-as__tabs {
  display: flex;
  gap: 0;
  margin-bottom: 16px;
  border-bottom: 1px solid #E1E5EE;
  flex-wrap: wrap;
}
.gx-as__tab {
  padding: 9px 18px;
  border: none;
  cursor: pointer;
  background: transparent;
  font-size: 13px;
  color: #4A4A6A;
  position: relative;
  transition: color .18s;
  white-space: nowrap;
}
.gx-as__tab--on {
  color: #C8443C;
  font-weight: 600;
}
.gx-as__tab--on::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: linear-gradient(90deg, #C8443C, #F07575);
}
.gx-as__tab-num {
  margin-left: 5px;
  padding: 1px 6px;
  border-radius: 8px;
  background: #FFFFFF;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: #6A6A8A;
}
.gx-as__table {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E1E5EE;
  margin-bottom: 16px;
  background: #FFFFFF;
}
.gx-as__table table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
.gx-as__table th {
  padding: 9px 14px;
  text-align: left;
  background: rgba(10, 21, 53, .75);
  font-size: 11px;
  font-weight: 500;
  color: #6A6A8A;
  letter-spacing: .04em;
  text-transform: uppercase;
}
.gx-as__table td {
  padding: 12px 14px;
  font-size: 12px;
  color: #1A1A2E;
  border-top: 1px solid rgba(212, 169, 70, .07);
}
.gx-as__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-as__link {
  color: #3FB6E0;
}
.gx-as__gold {
  color: #E8C778;
  font-weight: 600;
}
.gx-as__dim {
  color: #6A6A8A;
}
.gx-as__product {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-as__tag {
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(251, 146, 60, .1);
  border: 1px solid rgba(251, 146, 60, .28);
  font-size: 11px;
  color: #FB923C;
}
.gx-as__status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
}
.gx-as__op {
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  background: #E6F4FF;
  border: 1px solid #91CAFF;
  font-size: 11px;
  color: #1677FF;
  white-space: nowrap;
}
.gx-as__op:hover {
  background: #1677FF;
  color: #fff;
}
.gx-as__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #6A6A8A;
}
.gx-as__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gx-as__pager-total {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-as__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-as__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-as__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-as__page--on {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  color: #F4F6F8;
  font-weight: 700;
}
</style>
